<div class="p-2 pb-0">
  <mat-card appearance="outlined" class="main-panel p-2 rounded-md">
    <mat-card-content class="px-0 pt-0">
      @if (!loading && error) {
        <div class="container-fluid">
          <p class="text-center">{{ errorMessage }}</p>
        </div>
      }
      @if (!error) {
        <div class="container-fluid">
          <div class="row px-0">
            @for (metricPair of metricPairings; track metricPair) {
              <div class="col-12 col-lg-6 col-xl-3 py-2">
                <div
                  class="px-2 py-3 rounded-md shadow position-relative d-flex flex-column align-items-center overflow-hidden justify-content-center bg-white-always h-100 mon-text-black"
                >
                  <div
                    class="position-absolute top-0 end-0 start-0 bottom-0 d-flex align-items-stretch justify-content-center"
                    style="z-index: 0"
                  >
                    <!-- Same tint while loading as when loaded, so tiles do not flash white on each interval change. -->
                    <div
                      class="{{ metricPair.classes }} w-100 h-100"
                      style="opacity: 0.35"
                    ></div>
                  </div>
                  <div class="w-100 h-100 position-relative">
                    <div
                      class="d-flex align-items-start justify-content-between w-100 mb-3"
                    >
                      <p class="fs-5 lh-1 mb-0" style="min-height: 40px">
                        {{ metricPair.heading }}
                      </p>
                      <mat-icon
                        class="w-fit lh-1 flex-shrink-0 fs-md-30 fs-mb-40 outline"
                        style="height: auto; width: auto"
                        >{{ metricPair.icon }}</mat-icon
                      >
                    </div>
                    <div class="w-100">
                      <h5
                        class="d-block w-100 my-0 text-start text-truncate fs-md-33 fs-mb-35"
                      >
                        @if (loading) {
                          <span class="skeleton d-block">
                            <span
                              class="skeleton-item d-block rounded"
                              style="width: 4ch; height: 1em"
                            ></span>
                          </span>
                        } @else if (
                          metricPair.metricName.toLowerCase().indexOf('value') >
                          -1
                        ) {
                          <span>
                            {{
                              Metric(metricPair.metricName).value
                                | currency: currencyAlphaCode
                            }}
                          </span>
                        } @else {
                          <span>
                            {{ Metric(metricPair.metricName).value | number }}
                          </span>
                        }
                      </h5>
                    </div>
                  </div>
                  <div class="flex-fill"></div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div
        class="d-flex align-items-stretch justify-content-start mt-3 gap-3 px-2"
      >
        @for (i of intervals; track i) {
          <div
            (click)="ChangeInterval(i.value)"
            class="pointer p-2 rounded-3 border text-center d-flex align-items-center justify-content-center interactable"
            [ngClass]="{
              'mon-border-success': interval.value === i.value,
              'mon-bg-success': interval.value === i.value,
              'mon-text-success': interval.value === i.value,
              'mon-bg-transparent': interval.value !== i.value,
              'text-dark': interval.value !== i.value,
            }"
          >
            <span>{{ i.name }}</span>
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
